import TelegramBlackIcon from "../images/resources/black/telegram.svg";
import TwitterBlackIcon from "../images/resources/black/twitter.svg";
import DiscordBlackIcon from "../images/resources/black/discord.svg";
import VikingBlackIcon from "../images/resources/black/viking.svg";
import UniswapBlackIcon from "../images/resources/black/uniswap.svg";
import EtherscanBlackIcon from "../images/resources/black/etherscan.svg";
import CoingeckoBlackIcon from "../images/resources/black/coingecko.svg";
import CoinmarketcapBlackIcon from "../images/resources/black/coinmarketcap.svg";
import DEXToolsBlackIcon from "../images/resources/black/dextools.svg";
import BittrexBlackIcon from "../images/resources/black/bittrex.svg";
import BancorBlackIcon from "../images/resources/black/bancor.svg";
import LinkedInBlackIcon from "../images/resources/black/linkedin.svg";
import MediumBlackIcon from "../images/resources/black/medium.svg";
import GithubBlackIcon from "../images/resources/black/github.svg";
import EmailBlackIcon from "../images/resources/black/email.svg";
import SnapshotBlackIcon from "../images/resources/black/snapshot.svg";
import DrcFoundationBlackIcon from "../images/resources/black/drc-foundation.svg";
import TrelloBlackIcon from "../images/resources/black/trello.svg";
import YoutubeBlackIcon from "../images/resources/black/youtube.svg";
import RedditBlackIcon from "../images/resources/black/reddit.svg";
import CommunityArtBlackIcon from "../images/resources/black/community-art.svg";
import OfficialStoreBlackIcon from "../images/resources/black/official-store.svg";
import YahooBlackIcon from "../images/resources/black/yahoo.svg";
import HackernoonBlackIcon from "../images/resources/black/hackernoon.svg";
import GitbookBlackIcon from "../images/resources/black/gitbook.svg";
import BloombergBlackIcon from "../images/resources/black/bloomberg.svg";
import ForbesBlackIcon from "../images/resources/black/forbes.svg";
import BusinessInsiderBlackIcon from "../images/resources/black/business-insider.svg";
import InvestingBlackIcon from "../images/resources/black/investing-com.svg";
import BenzingaBlackIcon from "../images/resources/black/benzinga.svg";
import CoinTelegraphBlackIcon from "../images/resources/black/cointelegraph.svg";

import TelegramWhiteIcon from "../images/resources/white/telegram.svg";
import TwitterWhiteIcon from "../images/resources/white/twitter.svg";
import DiscordWhiteIcon from "../images/resources/white/discord.svg";
import VikingWhiteIcon from "../images/resources/white/viking.svg";
import UniswapWhiteIcon from "../images/resources/white/uniswap.svg";
import EtherscanWhiteIcon from "../images/resources/white/etherscan.svg";
import CoingeckoWhiteIcon from "../images/resources/white/coingecko.svg";
import CoinmarketcapWhiteIcon from "../images/resources/white/coinmarketcap.svg";
import DEXToolsWhiteIcon from "../images/resources/white/dextools.svg";
import BittrexWhiteIcon from "../images/resources/white/bittrex.svg";
import BancorWhiteIcon from "../images/resources/white/bancor.svg";
import LinkedInWhiteIcon from "../images/resources/white/linkedin.svg";
import MediumWhiteIcon from "../images/resources/white/medium.svg";
import GithubWhiteIcon from "../images/resources/white/github.svg";
import EmailWhiteIcon from "../images/resources/white/email.svg";
import SnapshotWhiteIcon from "../images/resources/white/snapshot.svg";
import DrcFoundationWhiteIcon from "../images/resources/white/drc-foundation.svg";
import TrelloWhiteIcon from "../images/resources/white/trello.svg";
import YoutubeWhiteIcon from "../images/resources/white/youtube.svg";
import RedditWhiteIcon from "../images/resources/white/reddit.svg";
import CommunityArtWhiteIcon from "../images/resources/white/community-art.svg";
import OfficialStoreWhiteIcon from "../images/resources/white/official-store.svg";
import YahooWhiteIcon from "../images/resources/white/yahoo.svg";
import HackernoonWhiteIcon from "../images/resources/white/hackernoon.svg";
import GitbookWhiteIcon from "../images/resources/white/gitbook.svg";
import BloombergWhiteIcon from "../images/resources/white/bloomberg.svg";
import ForbesWhiteIcon from "../images/resources/white/forbes.svg";
import BusinessInsiderWhiteIcon from "../images/resources/white/business-insider.svg";
import InvestingWhiteIcon from "../images/resources/white/investing-com.svg";
import BenzingaWhiteIcon from "../images/resources/white/benzinga.svg";
import CoinTelegraphWhiteIcon from "../images/resources/white/cointelegraph.svg";

export const communityLinks = {
  telegram: {
    displayLabel: "DRC<br>Telegram",
    url: "https://t.me/DigitalReserveCurrency",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  telegramAnnouncements: {
    displayLabel: "Announcements<br>Telegram",
    url: "https://t.me/DRC_Announcements",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  telegramChinese: {
    displayLabel: "Chinese<br>Telegram",
    url: "https://t.me/joinchat/RXIeLhu4Z96Y38jir7phuQ",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  telegramOutreach: {
    displayLabel: "Outreach<br>Telegram",
    url: "https://t.me/DRC_Outreach",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  telegramAfrica: {
    displayLabel: "Africa<br>Telegram",
    url: "https://t.me/drcafrica",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  telegramRussia: {
    displayLabel: "Russia<br>Telegram",
    url: "https://t.me/DRCRussia",
    iconBlack: TelegramBlackIcon,
    iconWhite: TelegramWhiteIcon,
  },
  twitter: {
    displayLabel: "DRC<br>Twitter",
    url: "https://twitter.com/DRCToken",
    iconBlack: TwitterBlackIcon,
    iconWhite: TwitterWhiteIcon,
  },
  discord: {
    displayLabel: "DRC<br>Discord",
    url: "https://discord.gg/qDwAauW",
    iconBlack: DiscordBlackIcon,
    iconWhite: DiscordWhiteIcon,
  },
  twitterVikings: {
    displayLabel: "DRC Vikings<br>Twitter",
    url: "https://twitter.com/DRCVikings",
    iconBlack: VikingBlackIcon,
    iconWhite: VikingWhiteIcon,
  },
  snapshot: {
    displayLabel: "DRC<br>Snapshot",
    url: "https://snapshot.org/#/drctoken.eth",
    iconBlack: SnapshotBlackIcon,
    iconWhite: SnapshotWhiteIcon,
  },
  trello: {
    displayLabel: "DRC<br>Trello Board",
    url: "https://trello.com/b/Go7Jrwc2/drc-foundation",
    iconBlack: TrelloBlackIcon,
    iconWhite: TrelloWhiteIcon,
  },
  drcFoundation: {
    displayLabel: "DRC Foundation<br>Website",
    url: "https://drc.foundation",
    iconBlack: DrcFoundationBlackIcon,
    iconWhite: DrcFoundationWhiteIcon,
  },
  youtube: {
    displayLabel: "DRC<br>YouTube",
    url: "https://www.youtube.com/channel/UCXkqt2I6CYex3M74ojxgRmg",
    iconBlack: YoutubeBlackIcon,
    iconWhite: YoutubeWhiteIcon,
  },
  reddit: {
    displayLabel: "DRC<br>Reddit",
    url: "https://www.reddit.com/r/DRCToken/",
    iconBlack: RedditBlackIcon,
    iconWhite: RedditWhiteIcon,
  },
  communityArt: {
    displayLabel: "DRC<br>Community Art",
    url: "https://freeimage.host/drcfoundation",
    iconBlack: CommunityArtBlackIcon,
    iconWhite: CommunityArtWhiteIcon,
  },
  officialStore: {
    displayLabel: "DRC Foundation<br>Official Store",
    url: "https://teespring.com/en-GB/stores/drcfoundation",
    iconBlack: OfficialStoreBlackIcon,
    iconWhite: OfficialStoreWhiteIcon,
  },
  gitbook: {
    displayLabel: "DRC<br>GitBook",
    url: "https://app.gitbook.com/@drc-foundation/s/drc-ecosystem/",
    iconBlack: GitbookBlackIcon,
    iconWhite: GitbookWhiteIcon,
  },
  gitbookRussian: {
    displayLabel: "DRC<br>Russian",
    url: "https://drc-foundation.gitbook.io/drc-translation/drc-global/ru-drc-global",
    iconBlack: GitbookBlackIcon,
    iconWhite: GitbookWhiteIcon,
  },
};

export const marketLinks = {
  uniswapInfo: {
    displayLabel: "DRC Info<br>Uniswap",
    url: "https://v2.info.uniswap.org/pair/0x53455f3b566d6968e9282d982dd1e038e78033ac",
    iconBlack: UniswapBlackIcon,
    iconWhite: UniswapWhiteIcon,
  },
  etherscan: {
    displayLabel: "DRC Info<br>Etherscan",
    url: "https://etherscan.io/token/0xa150Db9b1Fa65b44799d4dD949D922c0a33Ee606",
    iconBlack: EtherscanBlackIcon,
    iconWhite: EtherscanWhiteIcon,
  },
  coingecko: {
    displayLabel: "DRC Info<br>CoinGecko",
    url: "https://www.coingecko.com/en/coins/digital-reserve-currency",
    iconBlack: CoingeckoBlackIcon,
    iconWhite: CoingeckoWhiteIcon,
  },
  coinMarketCap: {
    displayLabel: "DRC Info<br>CoinMarketCap",
    url: "https://coinmarketcap.com/currencies/digital-reserve-currency/",
    iconBlack: CoinmarketcapBlackIcon,
    iconWhite: CoinmarketcapWhiteIcon,
  },
  uniswapTrade: {
    displayLabel: "DRC/ETH<br>Uniswap",
    url: "https://app.uniswap.org/#/swap?outputCurrency=0xa150db9b1fa65b44799d4dd949d922c0a33ee606&use=V2",
    iconBlack: UniswapBlackIcon,
    iconWhite: UniswapWhiteIcon,
  },
  bittrex: {
    displayLabel: "DRC/ETH<br>Bittrex",
    url: "https://global.bittrex.com/Market/Index?MarketName=ETH-DRC",
    iconBlack: BittrexBlackIcon,
    iconWhite: BittrexWhiteIcon,
  },
  bancor: {
    displayLabel: "DRC/ETH<br>Bancor",
    url: "https://app.bancor.network/eth/swap?from=0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE&to=0xa150Db9b1Fa65b44799d4dD949D922c0a33Ee606",
    iconBlack: BancorBlackIcon,
    iconWhite: BancorWhiteIcon,
  },
  dexTools: {
    displayLabel: "DRC/ETH<br>DEXTools",
    url: "https://www.dextools.io/app/uniswap/pair-explorer/0x53455f3b566d6968e9282d982dd1e038e78033ac",
    iconBlack: DEXToolsBlackIcon,
    iconWhite: DEXToolsWhiteIcon,
  },
};

export const informationLink = {
  linkedIn: {
    displayLabel: "LinkedIn",
    url: "https://www.linkedin.com/company/drc-global",
    iconBlack: LinkedInBlackIcon,
    iconWhite: LinkedInWhiteIcon,
  },
  medium: {
    displayLabel: "Medium",
    url: "https://medium.com/@digitalreservecurrency",
    iconBlack: MediumBlackIcon,
    iconWhite: MediumWhiteIcon,
  },
  github: {
    displayLabel: "Github",
    url: "https://github.com/digitalreserve",
    iconBlack: GithubBlackIcon,
    iconWhite: GithubWhiteIcon,
  },
  email: {
    displayLabel: "Email",
    url: "mailto:info@drcglobal.org",
    iconBlack: EmailBlackIcon,
    iconWhite: EmailWhiteIcon,
  },
};

export const publicationLink = {
  bloomberg: {
    displayLabel: "Bloomberg",
    url: "https://www.bloomberg.com/press-releases/2020-12-10/digital-reserve-currency-drc-is-a-potential-store-of-value-in-the-digital-age",
    iconBlack: BloombergBlackIcon,
    iconWhite: BloombergWhiteIcon,
  },
  yahoo: {
    displayLabel: "Yahoo! Finance",
    url: "https://finance.yahoo.com/news/digital-currency-drc-set-become-014000436.html",
    iconBlack: YahooBlackIcon,
    iconWhite: YahooWhiteIcon,
  },
  forbes: {
    displayLabel: "Forbes",
    url: "https://www.forbes.com/sites/kenrapoza/2021/01/26/telegram-gains-on-whatsapp-blunder-disgust-with-legacy-social-media/?sh=3cb19e4e7346",
    iconBlack: ForbesBlackIcon,
    iconWhite: ForbesWhiteIcon,
  },
  businessInsider: {
    displayLabel: "Business Insider",
    url: "https://markets.businessinsider.com/news/stocks/new-defi-platform-is-focused-exclusively-on-store-of-value-services-1030145811",
    iconBlack: BusinessInsiderBlackIcon,
    iconWhite: BusinessInsiderWhiteIcon,
  },
  investing: {
    displayLabel: "Investing.com",
    url: "https://www.investing.com/news/cryptocurrency-news/digital-reserve--innovative-defi-platform-to-hedge-inflation-risks-2434602",
    iconBlack: InvestingBlackIcon,
    iconWhite: InvestingWhiteIcon,
  },
  hackernoon: {
    displayLabel: "Hackernoon",
    url: "https://hackernoon.com/bitcoin-demonstrating-the-need-for-a-fully-decentralized-financial-system-maxim-nurov-sg3b31zl",
    iconBlack: HackernoonBlackIcon,
    iconWhite: HackernoonWhiteIcon,
  },
  benzinga: {
    displayLabel: "Benzinga",
    url: "https://www.benzinga.com/pressreleases/21/03/ac20007695/digital-reserve-platform-hedge-inflation-risks-with-decentralized-finance",
    iconBlack: BenzingaBlackIcon,
    iconWhite: BenzingaWhiteIcon,
  },
  coinTelegraph: {
    displayLabel: "CoinTelegraph",
    url: "https://cointelegraph.com/news/new-platform-delivers-well-balanced-portfolios-featuring-digital-assets",
    iconBlack: CoinTelegraphBlackIcon,
    iconWhite: CoinTelegraphWhiteIcon,
  },
};
